module.exports = __webpack_public_path__ + "static/ousamah-ca78d14d497e15c6ba087876dbe8029e.png";